import { createSlice } from '@reduxjs/toolkit'

export const historySlice = createSlice({
  name: 'historicalChatID',
  initialState: {
    value: '',
  },
  reducers: {
    updateHistoryID: (state, action) => {
      state.value = action.payload
    },
  }
})
// Action creators are generated for each case reducer function
export const { updateHistoryID } = historySlice.actions

export default historySlice.reducer